import { render, staticRenderFns } from "./selectSource.vue?vue&type=template&id=c2455538&scoped=true"
import script from "./selectSource.vue?vue&type=script&lang=js"
export * from "./selectSource.vue?vue&type=script&lang=js"
import style0 from "./selectSource.vue?vue&type=style&index=0&id=c2455538&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c2455538",
  null
  
)

export default component.exports